import React, { useState, useRef, useEffect } from 'react';
import {
  Arrow,
  ArrowWrapper,
  Row,
  SpoilerContent,
  SpoilerContentRoller,
  SpoilerSummary,
  SpoilerWrapper,
} from './spoilerStyled';
const Spoiler: React.FC<{
  summary: string | JSX.Element;
  open?: boolean;
  summaryStyle?: React.CSSProperties;
  spoilerContent: JSX.Element | String;
  spoilerContentStyle?: React.CSSProperties;
  spoilerWrapperStyle?: React.CSSProperties;
  onChangeState?: (isOpen: boolean) => void;
}> = ({
  summary,
  open = false,
  summaryStyle = {},
  spoilerContent,
  spoilerContentStyle = {},
  spoilerWrapperStyle = {},
  onChangeState,
}) => {
  const [isOpen, setIsOpen] = useState(open);
  const [height, setHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleSpoiler = () => {
    setIsOpen(!isOpen);
    onChangeState?.(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [isOpen]);

  return (
    <SpoilerWrapper style={spoilerWrapperStyle}>
      <Row onClick={toggleSpoiler}>
        <SpoilerSummary style={summaryStyle}>{summary}</SpoilerSummary>
        <ArrowWrapper>
          <Arrow show={isOpen} />
        </ArrowWrapper>
      </Row>
      <SpoilerContentRoller isOpen={isOpen} height={height}>
        <SpoilerContent ref={contentRef} style={spoilerContentStyle}>
          {spoilerContent}
        </SpoilerContent>
      </SpoilerContentRoller>
    </SpoilerWrapper>
  );
};

export default Spoiler;
